export default __webpack_public_path__ + "static/media/hospitality4.f5706374.jpg";